import { privateGateway } from '../../../config';

export const deleteUserRequest = async (requestId: string): Promise<void> => {
  await privateGateway(
    process.env.REACT_APP_USER_CONTROLLER_API_GATEWAY as string
  ).delete(`/user_requests/${requestId}`);
};
